/**
 * @description 发货通知单
 * @author: 菩萨蛮
 * @date 2020/9/24 9:28 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

import OrderBase from '../OrderBase';
import NoticeOrderDetail from './child/NoticeOrderDetail';
import moment from 'moment';

const NoticeOrder = {
  ...OrderBase,
  id: { title: '编号', visible: { new: false, modify: false }, search: true, isShow: true, fieldIsShow: true, style: { width: '140px'} },
  status: { title: '状态', type: 'status', visible: { new: false, modify: false }, fieldIsShow: true  },
  relateWarehouse: { title: '是否关联仓储', visible: false, type: 'boolean', defaultValue: true },
  goodsType: {
    title: '物品类型',
    type: 'select',
    required: true,
    search: true,
    selectList: [
      { label: '成品', value: '成品' },
      { label: '坯布', value: '坯布' },
      { label: '纱线', value: '纱线' }
    ],
    defaultValue: '成品',
    disabled: {
      new: false, modify: true
    },
    sort: 0,
    fieldIsShow: true 
  },
  type: {
    title: '类别',
    type: 'select',
    required: true,
    selectList: [{ label: '内销', value: '1' }],
    visible: false
  },
  custId: { title: '客户id', visible: false },
  custName: { title: '客户名称', type: 'cust', required: true, search: true, fieldIsShow: true, style: { width: '240px'} },
  contactName: {
    title: '收货人',
    required: true,
    type: 'slot',
    visible: { table: false }
  },
  contactPhone: {
    title: '联系方式',
    required: true,
    style: { width: '130px' },
    visible: { table: false }
  },
  address: {
    title: '联系地址',
    type: 'slot',
    required: true,
    disabled: true,
    // visible: { table: false },
    fieldIsShow: true,
    style: { width: '280px'}
  },
  deliveryTime: {
    title: '发货日期',
    type: 'date',
    search: true,
    isShow: false,
    required: true,
    style: { width: '110px' },
    defaultValue: moment().format('yyyy-MM-DD'),
    fieldIsShow: true 
  },
  userId: { title: '类型id', visible: false },
  userName: { title: '类型', required: true, type: 'slot', search: true },
  orderOperatorName: { title: '下单人', required: true, type: 'slot', fieldIsShow: true },
  orderOperatorId: { title: '下单人id', visible: false },
  transferInfo: { title: '中转站', visible: { table: false } },
  orderDetails: {
    title: '订单明细',
    type: 'list',
    visible: false,
    qxClassType: 'list',
    qxJson: NoticeOrderDetail
  },
  gmtCreate: {
    type: 'date',
    title: '创建时间',
    visible: { table: true, modify: false, new: false },
    search: true,
    isShow: false,
    sort: 999,
    fieldIsShow: true,
    style: { width: '160px'}
  }
};
export default NoticeOrder;
